import getObjectKey from 'lib/object/getObjectKey'

const UPGRADE_KEY_PREFIX = 'originUniqueKey'

function buildLoyaltySelectedUpgradeKey(
  originPackage: App.Package | App.HotelPackage,
  /**
   * @todo Room number should be included in the key to avoid overlaps.
   */
  // roomNumber: number,
): string | undefined {
  return getObjectKey({
    [UPGRADE_KEY_PREFIX]: originPackage.uniqueKey,
    // roomNumber,
  })
}

export default buildLoyaltySelectedUpgradeKey

/**
 * Returns the origin package unique key from a given upgrade key.
 */
export function getSelectedUpgradeOriginUniqueKey(
  upgradeKey: string,
) {
  return upgradeKey.match(`${UPGRADE_KEY_PREFIX}=([^=]+)`)?.[1]
}
